export default __webpack_public_path__ + "static/media/adwmainz.7baed2fe.png";